import { get } from 'lodash';

import * as AT from '../../action-types';
import {
  patientIdUrlParamName,
  baseUrlParamName,
  companyIdUrlParamName,
  patientTypeParamName,
  isInlineModeParamName,
  isInlineEditParamName,
  isMidcSourceUrlParamName,
  dateOfBirthFormatUrlParamName,
  shouldHideGenderAndDob,
  iframeIdUrlParamName,
  isIntuitiveFlowUrlParamName,
  isInitialConfirmAllowedUrlParamName,
  isRxTakenForScanUrlParamName
} from '../../../consts';

const getBoolFromUrlParam = value => {
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true';
  }
  return value === true;
};

const INIT_STATE = {
  config: {},
  fromUrl: {
    iframeId: '',
    endpoint: '',
    companyId: '',
    patientId: '',
    patientType: '',
    isInlineMode: false,
    isInlineEdit: false,
    dateOfBirthFormat: '',
    isMidcSource: true,
    isRxTakenForScan: false
  },
  showLoader: true
};

const featureName = AT.SHELL;

const appConfigReducer = (state = INIT_STATE, action) => {
  const { type, payload } = action;
  const feature = get(action, 'meta.feature');

  if (feature !== featureName) {
    return state;
  }

  switch (type) {
    case AT.SET_APP_CONFIG:
      return {
        ...state,
        config: payload
      };
    case AT.SET_URL_PARAMS:
      return {
        ...state,
        fromUrl: {
          iframeId: payload[iframeIdUrlParamName],
          endpoint: payload[baseUrlParamName],
          patientId: payload[patientIdUrlParamName],
          companyId: payload[companyIdUrlParamName],
          patientType: payload[patientTypeParamName],
          isInlineMode: getBoolFromUrlParam(payload[isInlineModeParamName]),
          isInlineEdit: getBoolFromUrlParam(payload[isInlineEditParamName]),
          isMidcSource: getBoolFromUrlParam(payload[isMidcSourceUrlParamName]),
          dateOfBirthFormat: payload[dateOfBirthFormatUrlParamName] ? payload[dateOfBirthFormatUrlParamName].toUpperCase() : '',
          shouldHideGenderAndDob: getBoolFromUrlParam(payload[shouldHideGenderAndDob]),
          isIntuitiveFlow: getBoolFromUrlParam(payload[isIntuitiveFlowUrlParamName]),
          isInitialConfirmAllowed: getBoolFromUrlParam(payload[isInitialConfirmAllowedUrlParamName]),
          isRxTakenForScan: getBoolFromUrlParam(payload[isRxTakenForScanUrlParamName])
        }
      };
    case AT.SET_SHOW_LOADER:
      return { ...state, showLoader: payload };
    default:
      return state;
  }
};

export default appConfigReducer;
